import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const loadEnglishTranslations = async () => {
    try {
        const enResources = await import("../../locales/en.json");
        i18n.addResourceBundle("en", "common", enResources, true);
    }
    catch (error) {
        console.error("Failed to load English translations:", error);
    }
};
loadEnglishTranslations().catch(console.error);
i18n
    .use(initReactI18next)
    .init({
    fallbackLng: "en",
    load: "currentOnly",
    returnObjects: true,
    interpolation: {
        escapeValue: false,
    },
    ns: ["common"],
    defaultNS: "common",
})
    .catch(console.error);
export { i18n };
//# sourceMappingURL=i18n.js.map